import {Config, defaultConfig} from './config';

type PseudoRandomNumber = number;
type PseudoRandomString = string;

interface Dependencies {
  randomSource?: () => PseudoRandomNumber;
}

export function uniqueString(
  config: Config = defaultConfig,
  di: Dependencies = {}
): PseudoRandomString {
  const {randomSource = Math.random} = di;
  const {alphabet, strength} = config;

  return Array(strength)
    .fill('')
    .map(() => Math.floor(randomSource() * alphabet.length))
    .map((index) => alphabet.charAt(index))
    .join('');
}
